import type { GetSubsidiariesResponse } from '@vy/api-definition';
import { GetSubsidiariesResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useSubsidiaries(options?: CustomUseQueryOptions<GetSubsidiariesResponse>) {
  return useQuery({
    queryKey: queryKeys.subsidiaries(),
    queryFn: async () => {
      const api = getPrivateApi();

      const subsidiariesResponse = await api.getSubsidiaries();

      return GetSubsidiariesResponseSchema.parse(subsidiariesResponse);
    },
    ...options,
  });
}
